import {IAuditWebServiceClient, ListIdsDto} from "@common/resources/resources";
import {environment} from "@environments/environment";
import {FactureDto, IFacturesWebServiceClient, RechercheFactureDto} from "@resources/resources";
import {NotificationService, UserStore} from "@digicerba/common";
import {
  AsiFileService,
  AsiTable,
  AsiTableData,
  AsiTableRequest,
  AsiTableSelectionModel
} from "@asi-ngtools/lib";

import {Component, Input, OnInit, SimpleChange, ViewChild} from "@angular/core";
import * as lodash from "lodash";

@Component({
  selector: 'factures-resultats',
  templateUrl: './factures-resultats.component.html',
  host: {'class': 'page'}
})
export class FacturesResultatsComponent implements OnInit{

  @Input() rechercheFactureDto: RechercheFactureDto;
  @ViewChild('dossierDataTable') articleTable: AsiTable<FactureDto>;

  asiTableData: AsiTableData<FactureDto> = new AsiTableData<FactureDto>();
  selectionModel = new AsiTableSelectionModel("id", false);
  currentSearchDto: RechercheFactureDto;

  constructor(private facturesWebService: IFacturesWebServiceClient,
              private fileUtils: AsiFileService,
              private auditWebServiceClient: IAuditWebServiceClient,
              private notificationService: NotificationService,
              private userStore: UserStore) {

  }

  ngOnInit() {
    this.currentSearchDto = {...this.rechercheFactureDto};
    this.currentSearchDto.nbElementsParPage = 25;
    this.currentSearchDto.pageIndex = 1;
  }

  refreshTable(asiTableRequest: AsiTableRequest) {
    this.currentSearchDto = {...this.rechercheFactureDto};
    this.currentSearchDto.nbElementsParPage = this.articleTable.nbElementParPage;
    this.currentSearchDto.pageIndex = asiTableRequest.pageIndex;
    if (this.rechercheFactureDto != null) {
      this.rechercheDossier();
    }
  }

  ngOnChanges(change: SimpleChange) {
    if (!change.firstChange) {
      this.articleTable.fireRefresh();
    }
  }

  private rechercheDossier() {
    this.facturesWebService.rechercherFactures(this.currentSearchDto).subscribe((resultats: any) => {
      this.asiTableData = {...resultats, paginate: true};
      this.articleTable.updateData(this.asiTableData);
    }, error => {
      if (error.status == 422) {
        this.notificationService.showErrorNotification("PAGE.SERVEUR-RESULTATS.FILTRE.unprocessable");
      }
    });
  }

  telechargerSelection() {
    let selec = this.getFacturesSelectionnees();
    this.telechargerFactures(selec);
  }

  private getFacturesSelectionnees(): Array<FactureDto> {
    let factures = new Array<FactureDto>();
    if (this.selectionModel.allChecked == false) {
      factures = this.selectionModel.itemsIncluded;
    } else {
      this.asiTableData.results.forEach(facture => {
        if (lodash.indexOf(this.selectionModel.itemsExcluded, facture) == -1) {
          factures.push(facture);
        }
      });
    }
    return factures;
  }

  telechargerFacture(row: FactureDto) {
    this.fileUtils.getFileAsBlob(environment.contextPath + "api/factures/document/" + row.id).subscribe((fileAsBlob) => {
      this.auditWebServiceClient.info({message: "Client " + this.userStore.getUser().login + " - Factures - Téléchargement du fichier de facture n°" + row.numeroFacture}).subscribe(info => {
        console.log("Log serveur done.");
      });

      this.saveToFile(fileAsBlob, "Facture n°" + row.numeroFacture + ".pdf");
    });
  }


  telechargerFactures(selec: Array<FactureDto>) {
    let listIds = new ListIdsDto();
    listIds.ids = selec.map(value => value.id);

    let numeros = [selec.map(value => value.numeroFacture)];

    this.fileUtils.getFileAsBlobFromPostRequest(environment.contextPath + "api/factures/documents/", listIds).subscribe((fileAsBlob) => {

      this.auditWebServiceClient.info({message: "Client " + this.userStore.getUser().login + " - Factures - Téléchargement des fichiers des factures n°" + numeros.join(", ")}).subscribe(info => {
        console.log("Log serveur done.");
      });

      this.saveToFile(fileAsBlob, "Factures.zip");
    });
  }

  saveToFile(fileAsBlob: Blob, fileName: string) {
    if (window.navigator.msSaveBlob) {
      window.navigator.msSaveBlob(fileAsBlob, fileName);
    } else {
      let url = window.URL.createObjectURL(fileAsBlob);
      var anchor = document.createElement("a");
      anchor.download = fileName;
      anchor.target = '_blank';
      anchor.href = url;
      anchor.dispatchEvent(new MouseEvent("click"));
      document.body.removeChild(anchor);
    }
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-factures/digicerba-factures-web/src/angular/cerba/src/app/pages/cerba/pages/factures/resultats/factures-resultats.component.ts